import { useAuth } from '@/contexts/AuthContext';
import { SubmitAppealDialog } from '@/components/SubmitAppealDialog';

/**
 * Global mount — öppnar SubmitAppealDialog automatiskt när signIn
 * returnerade 'BANNED:*'-fel och AuthContext satte lastBanBlock.
 *
 * Ligger i App.tsx under AuthProvider så alla rutter har tillgång.
 *
 * Performance-fix: unmounta komponenten helt när det INTE finns en
 * aktiv ban-block. Detta undviker att shadcn Dialog hamnar i ett
 * stuck-state där overlay kvarstår trots open=false (radix-ui-portal-
 * cleanup-race vid StrictMode HMR).
 */
export function BanAppealMount() {
  const { lastBanBlock, clearLastBanBlock } = useAuth();

  // Viktigt: returnera null när ingen ban — unmountar dialogen helt
  // istället för att ha den i DOM med open={false}. Fixar overlay-stuck.
  if (!lastBanBlock) return null;

  return (
    <SubmitAppealDialog
      open={true}
      onOpenChange={(o) => { if (!o) clearLastBanBlock(); }}
      banState={lastBanBlock.state ?? undefined}
      banReason={lastBanBlock.reason ?? undefined}
    />
  );
}
